import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    companyName: "",
    branchName: "",
};
export const companySlice = createSlice({
    name: "company",
    initialState: initialState,
    reducers: {
        changeCompany: (state, action) => {
            state.companyName = action.payload.companyName;
            state.branchName = action.payload.branchName;
        },
    }
})

export const {changeCompany} = companySlice.actions;
export default companySlice.reducer;